import { ExternalLink } from "lucide-react"
import { classes } from "@/utils"

/** Deep link into the promotions page that opens this promotion's popup. */
export function promotion_url(promotion_id: string): string {
  return `/trade-promotion-management?promotion=${encodeURIComponent(promotion_id)}`
}

interface OpenPromotionLinkProps {
  promotion_id: string
  /** Show the "Open promotion" label next to the icon. Icon-only when false. */
  show_label?: boolean
  className?: string
}

/** Opens a matched promotion on the promotions page in a new tab. */
export function OpenPromotionLink({ promotion_id, show_label = true, className }: OpenPromotionLinkProps) {
  return (
    <a
      href={promotion_url(promotion_id)}
      target="_blank"
      rel="noopener noreferrer"
      title="Open promotion"
      aria-label="Open promotion"
      class={classes("inline-flex items-center gap-1 text-xs text-blue-600 hover:underline", className)}
      onClick={(e: Event) => e.stopPropagation()}>
      <ExternalLink className="h-3 w-3 shrink-0" />
      {show_label && <span>Open promotion</span>}
    </a>
  )
}
